module.exports = __webpack_public_path__ + "static/img/dawan_cjwt2.aca9d5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dawan/dawan_cjwt2.png
// module id = 705
// module chunks = 0